export default /* glsl */`
highp vec2 resolution = vec2(uResolution);

float h = max(resolution.x, resolution.y * aspect);
float shift = progress * (resolution.y - h);
float r0 = (shift + ratio0 * h) / resolution.y;
float r1 = (shift + ratio1 * h) / resolution.y;

vec3 color = mixLinearGradientColors(color0, color1, r0, r1, rotate, gl_FragCoord.xy, resolution, fixChubb);
`;
